<template>
  <el-menu
    :default-active="activeIndex2"
    class="el-menu-navbar"
    mode="horizontal"
    background-color="#545c64"
    text-color="#fff"
    active-text-color="#ffd04b"
  >
    <el-menu-item class="navbar-brand" index="1">
      <router-link class="nav" to="/">Calculators</router-link>
    </el-menu-item>
    <el-submenu index="2">
      <template #title>Health</template>
      <el-menu-item index="2-1">
        <router-link class="nav" to="/bmi">BMI</router-link>
      </el-menu-item>
      <el-menu-item index="2-2">
        <router-link class="nav" to="/bodyfat">Body Fat</router-link>
      </el-menu-item>
    </el-submenu>
    <el-submenu index="3">
      <template #title>Maths</template>
      <el-menu-item index="3-1">
        <router-link class="nav" to="/percent">Percentage</router-link>
      </el-menu-item>
      <el-menu-item index="3-2">
        <router-link class="nav" to="/bitwise">Bitwise</router-link>
      </el-menu-item>
    </el-submenu>
    <el-menu-item index="4">
      <router-link class="nav" to="/conversion">Conversions</router-link>
    </el-menu-item>
    <el-menu-item index="5">
      <router-link class="nav" to="/about">About</router-link>
    </el-menu-item>
    <div class="menu-display">
      <span>Decimal Places</span>
      <el-input-number v-model="decimalPlaces" :min="0" :max="10" size="mini" />
    </div>
  </el-menu>
</template>

<script lang="ts">
export default {
  data() {
    return {
      activeIndex: "1",
      activeIndex2: "1",
    }
  },
  computed: {
    decimalPlaces: {
      get() {
        return this.$store.state.decimalPlaces
      },
      set(newDecimalPlaces) {
        this.$store.commit("changeDecimalPlaces", newDecimalPlaces)
      },
    },
  },
}
</script>

<style>
</style>
